import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { NudgesService } from '../../global-services/nudges.service';
import { AMPLITUDE_EVENT_CATEGORIES, AMPLITUDE_EVENTS, AmplitudeService } from '../../global-services/amplitude.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-download-cards-app-topbar-mobile-nudge',
    templateUrl: './download-cards-app-topbar-mobile-nudge.component.html',
    styleUrls: ['./download-cards-app-topbar-mobile-nudge.component.scss'],
    standalone: false
})
export class DownloadCardsAppTopbarMobileNudgeComponent implements OnInit {
  
  appStoreUrl = environment.appStoreUrl;
  playStoreUrl = environment.playStoreUrl;
  
  showBanner: boolean = false; // Controlled by service logic
  installButtonText: string = 'Install App';
  deviceOs: string;

  private readonly ngUnsubscribe = new Subject<void>();

  constructor(
    private readonly nudgesService: NudgesService, 
    private readonly amplitudeService: AmplitudeService,
    private readonly deviceDetectorService: DeviceDetectorService
  ) {}

  ngOnInit() {
    this.deviceOs = this.deviceDetectorService.getDeviceInfo().os;
    // Subscribe to banner visibility from service
    this.nudgesService.topbarNudgeVisible$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((visible) => {
      this.showBanner = visible;
    });
  }

  onCloseBanner(): void {
    this.showBanner = false;
    // Update service when banner is hidden
    this.nudgesService.dismissTopbarNudge();
    this.amplitudeService.logEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, AMPLITUDE_EVENTS.MOBILE_APP_MODAL_DISMISSED, {
      triggered_from: 'top',
      application: 'PWA',
      launch_modal: false,
    });
  }

  onInstallApp(): void {
    this.amplitudeService.logEvent(AMPLITUDE_EVENT_CATEGORIES.Usage, AMPLITUDE_EVENTS.MOBILE_APP_NUDGE_ACTION_CLICKED, {
      triggered_from: 'top',
      application: 'PWA',
      cta: 'install_app',
    });
    
    if (this.deviceOs === 'Android') {
      window.open(this.playStoreUrl, '_blank');
    } else if (this.deviceOs === 'iOS') {
      window.open(this.appStoreUrl, '_blank');
    }
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

} 